import React, { memo, useEffect } from "react";
import { captureEvent } from "../../../utils/posthogUtils";

const Dashboard = () => {
  useEffect(() => {
    captureEvent("Page Viewed: User Dashboard");
  }, []);

  return <div>Dashboard</div>;
};

export default memo(Dashboard);
